import Papa from 'papaparse'
import { isEmpty } from 'lodash'

// Option caps mirror the existing option editors: pick_list resolves a name-only
// answer against a large list; categorization classifies against a described,
// deliberately smaller set.
export const PICK_LIST_MAX_OPTIONS = 150
export const CATEGORIZATION_MAX_OPTIONS = 30

export const maxOptionsFor = (isCategorization) =>
  isCategorization ? CATEGORIZATION_MAX_OPTIONS : PICK_LIST_MAX_OPTIONS

// Read an uploaded options CSV into { name, description }[]. Recognizes an
// `option` column (aliased `name`) case-insensitively, plus a `description`
// column when descriptions apply (categorization). Rows with no option name are
// dropped so trailing/blank lines don't become empty options.
//
// Returns { options } on success, or { error } naming what's wrong so the caller
// can surface a specific message: a missing option column, a missing description
// column when descriptions are required, or no usable rows.
export const readOptionsCsv = (csvText, { withDescriptions = false } = {}) => {
  const { data, meta } = Papa.parse(csvText, { header: true, skipEmptyLines: true })
  const columns = (meta?.fields ?? []).map((field) => field.trim().toLowerCase())

  if (!columns.includes('option') && !columns.includes('name')) {
    return { error: 'missingOption' }
  }
  if (withDescriptions && !columns.includes('description')) {
    return { error: 'missingDescription' }
  }

  const getValue = (row, header) => {
    const target = header.toLowerCase()
    const match = Object.keys(row).find((column) => column.trim().toLowerCase() === target)
    return match ? String(row[match] ?? '').trim() : ''
  }
  const options = data
    .map((row) => ({
      name: getValue(row, 'option') || getValue(row, 'name'),
      description: withDescriptions ? getValue(row, 'description') : '',
    }))
    .filter((option) => !isEmpty(option.name))

  if (isEmpty(options)) {
    return { error: 'empty' }
  }
  return { options }
}
